import { supportedChains } from '@lifi/sdk';
import WalletConnectProvider from '@walletconnect/ethereum-provider';
import { initializeConnector } from '@web3-react/core';
import { Connector } from '@web3-react/types';
export class WalletConnect extends Connector {
    constructor(actions, options) {
        super(actions);
        this.isCurrentlyUsed = false;
        this.connectEagerly = () => { };
        this.options = options;
    }
    async startListening() {
        // Subscribe to accounts change
        this.provider?.on('accountsChanged', (accounts) => {
            this.actions.update({ accounts });
        });
        // Subscribe to chainId change
        this.provider?.on('chainChanged', (chainId) => {
            this.actions.update({ chainId });
        });
        // Subscribe to session disconnection
        this.provider?.on('disconnect', (code, reason) => {
            this.actions.update({ accounts: [], chainId: undefined });
            this.actions.resetState();
            this.isCurrentlyUsed = false;
        });
    }
    async activate() {
        this.actions.startActivation();
        this.isCurrentlyUsed = true;
        // Reset provider for every connection attempt
        const walletConnectProvider = new WalletConnectProvider({
            rpc: this.options.rpc,
        });
        this.provider =
            walletConnectProvider;
        this.walletConnectProvider = walletConnectProvider;
        await this.provider?.enable(); // open modal
        this.startListening();
        this.actions.update({ accounts: this.provider.accounts });
        this.actions.update({ chainId: this.provider.chainId });
    }
    async deactivate() {
        if (this.provider) {
            await this.provider?.disconnect();
            this.isCurrentlyUsed = false;
            this.actions.resetState();
        }
    }
}
export const [walletConnect, hooks] = initializeConnector((actions) => new WalletConnect(actions, {
    rpc: Object.fromEntries(supportedChains.map((chain) => {
        return [chain.id, chain.metamask.rpcUrls[0] || ''];
    })),
}));
export const createWalletConnectConnector = () => {
    const [connector, hooks] = initializeConnector((actions) => new WalletConnect(actions, {
        rpc: Object.fromEntries(supportedChains.map((chain) => {
            return [chain.id, chain.metamask.rpcUrls[0] || ''];
        })),
    }));
    return { connector, hooks };
};
